import { render } from "./NoResultsSection.vue?vue&type=template&id=76d3aa0a"
import script from "./NoResultsSection.vue?vue&type=script&lang=js"
export * from "./NoResultsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__